const insertMarkToSearchElements = (text, position, length) => `${text.slice(0, position)
}<mark class="mark">${
  text.slice(position, position + length)
}</mark>${
  text.slice(position + length)}`;

export const searchMatchesElements = (options, inputValue) => options.map((option) => {
  const searchMatchesText = option.text.toLowerCase().search(inputValue.toLowerCase());
  if (searchMatchesText !== -1) {
    return {
      text: insertMarkToSearchElements(
        option.text,
        searchMatchesText,
        inputValue.toLowerCase().length,
      ),
      value: option.value,
    };
  }
  return null;
}).filter((text) => !!text);

export default {
  searchMatchesElements,
};
